export default "__VITE_ASSET__GNYqsOW5__"